import {FIELD_MAPPING_TYPE} from 'src/interfaces/Platform.interface'

export type MappingWithMeta = FIELD_MAPPING_TYPE & Record<string, any>

export const buildFieldMappingMetaMap = (
  fieldMappings?: FIELD_MAPPING_TYPE[] | null
): Map<string, FIELD_MAPPING_TYPE> => {
  const metaMap = new Map<string, FIELD_MAPPING_TYPE>()
  if (!Array.isArray(fieldMappings)) {
    return metaMap
  }

  fieldMappings.forEach((meta) => {
    if (!meta) {
      return
    }
    const identifiers = [meta.field_code, meta.api_code].filter(Boolean) as string[]
    identifiers.forEach((identifier) => {
      if (!metaMap.has(identifier)) {
        metaMap.set(identifier, meta)
      }
    })
  })

  return metaMap
}

export const enrichFieldMapping = <T extends MappingWithMeta>(
  mapping: T,
  metaMap: Map<string, FIELD_MAPPING_TYPE>
): T => {
  if (!metaMap.size) {
    return mapping
  }

  const codes = [
    mapping?.field_code,
    mapping?.api_code,
    mapping?.destination_field?.api_code,
    mapping?.source_field?.api_code,
  ].filter(Boolean) as string[]

  const meta =
    codes.map((code) => metaMap.get(code)).find((candidate) => candidate !== undefined) ?? null

  if (!meta) {
    return mapping
  }

  const enriched: T = {...mapping}

  if (enriched.belongs_to_id === undefined || enriched.belongs_to_id === null) {
    enriched.belongs_to_id = meta.belongs_to_id ?? null
  }

  if (enriched.setting_mapping_id === undefined || enriched.setting_mapping_id === null) {
    enriched.setting_mapping_id = meta.setting_mapping_id ?? null
  }

  if (!enriched.input_type && meta.input_type) {
    enriched.input_type = meta.input_type
  }

  if (!enriched.field_code && meta.field_code) {
    enriched.field_code = meta.field_code
  }

  if (!enriched.platformfielddata_set && meta.platformfielddata_set) {
    enriched.platformfielddata_set = meta.platformfielddata_set
  }

  if (!enriched.map_with && meta.map_with) {
    enriched.map_with = meta.map_with
  }

  if (enriched.enable_shortcodes === undefined && meta.enable_shortcodes !== undefined) {
    enriched.enable_shortcodes = meta.enable_shortcodes
  }

  if (enriched.shortcode_options === undefined && meta.shortcode_options !== undefined) {
    enriched.shortcode_options = meta.shortcode_options
  }

  if (
    (enriched as MappingWithMeta).is_advance_setting === undefined ||
    (enriched as MappingWithMeta).is_advance_setting === null
  ) {
    ;(enriched as MappingWithMeta).is_advance_setting = meta.is_advance_setting
  }

  return enriched
}
